import getRestaurant from '@menu/Utils/getRestaurant';

export default (
  price: number,
  { currencyCode }: { currencyCode?: string } = {},
) => {
  const restaurant = getRestaurant();

  currencyCode = currencyCode ?? restaurant.currencyCode;

  const defaultFractionDigits = restaurant.currencyFractionDigits ?? 2;

  const fractionDigits = price % 1 === 0 ? 0 : defaultFractionDigits;

  if (currencyCode === 'EUR') {
    return `${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price)}€`;
  }

  if (currencyCode === 'JPY') {
    return `¥${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price)}`;
  }

  if (currencyCode === 'IRT') {
    return `${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price)} T`;
  }

  if (currencyCode === 'AED') {
    // \uE800 stands for AED currency symbol and comes from the ApetitoMenuPUA font
    return `\uE800 ${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price)}`;
  }

  if (currencyCode === 'SAR') {
    // \uE801 stands for SAR currency symbol and comes from the ApetitoMenuPUA font
    return `\uE801 ${new Intl.NumberFormat('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    }).format(price)}`;
  }

  return `${currencyCode} ${new Intl.NumberFormat('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(price)}`;
};
